import { createRoute } from "@tanstack/react-router";

import { requirePermission } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { BillingPage } from "./billing.page";

export const billingRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/billing",
	beforeLoad: ({ context }) => requirePermission(context.queryClient, { billing: ["manage"] }),
	component: BillingPage,
});
